function About() {
  return (
    <section className="py-16 pt-24 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-navy text-center mb-12 animate-fade-in">About Exo Contracting Inc.</h1>
        <div className="max-w-3xl mx-auto text-gray-600 space-y-6">
          <p className="text-lg animate-fade-in delay-100">Exo Contracting Inc. is a leading provider of specialized painting services for bridges, water towers, and commercial properties. With over 20 years of experience, we deliver high-quality, durable, and eco-friendly solutions tailored to our clients' needs.</p>
          <p className="text-lg animate-fade-in delay-200">Our mission is to protect and enhance critical infrastructure through expert craftsmanship, innovative techniques, and a commitment to safety and sustainability.</p>
          <h2 className="text-2xl font-semibold text-navy mt-8">Our Team</h2>
          <p className="text-lg animate-fade-in delay-300">Our team of certified professionals brings expertise in industrial coatings, project management, and safety compliance, ensuring every project meets the highest standards.</p>
        </div>
      </div>
    </section>
  );
}

export default About;